<template>
  <div id="sidebar-menu">
    <ul class="sidebar-links custom-scrollbar sidebar-menu-scroll" id="myDIV" :style="[
      layoutobject.split(' ').includes('horizontal-wrapper') ? layout.settings.layout_type == 'rtl' ? { '  -right': margin + 'px' } : { 'margin-left': margin + 'px' } : { margin: '0px' },
    ]">
      <li class="back-btn">
        <div class="mobile-back text-right">
          <span>Back</span> <i class="fa fa-angle-right pl-2" aria-hidden="true"></i>
        </div>
      </li>
      <li class="menu-box">
        <ul>
          <li v-for="(menu, index) in menuItems" :key="index" class="sidebar-list">
            <label :class="'badge badge-' + menu.badgeType" v-if="menu.badgeType">{{ menu.badgeValue }}</label>
            <a href="javascript:void(0)" :class="{ active: menu.active }" class="sidebar-link sidebar-title"
              v-if="menu.type == 'sub'" @click="setNavActive(menu, index)">
              <vue-feather :type="menu.icon" class="top"></vue-feather>
              <span>{{ $t(menu.title) }}</span>
              <div class="according-menu" v-if="menu.children">
                <i class="pull-right" :class="[menu.active ? 'fa fa-angle-down' : 'fa fa-angle-right']"></i>
              </div>
            </a>
            <router-link :to="menu.path" class="sidebar-link sidebar-title" v-if="menu.type == 'link'"
              router-link-exact-active exact v-on:click="hidesecondmenu()">
              <vue-feather :type="menu.icon" class="top"></vue-feather>
              <span>{{ $t(menu.title) }}</span>
            </router-link>
            <a :href="menu.path" class="sidebar-link sidebar-title" target="_blank" v-if="menu.type == 'extLink'">
              <vue-feather :type="menu.icon" class="home"></vue-feather>
              <span class="menu1">{{ $t(menu.title) }}</span>
            </a>
            <ul class="sidebar-submenu" v-if="menu.children"
              :class="sidebarType == 'default' ? menu.active ? 'd-block' : 'd-none' : ''">
              <li v-for="(childrenItem, childIndex) in menu.children" :key="childIndex">
                <router-link :to="childrenItem.path" v-if="childrenItem.type == 'link'" router-link-exact-active exact
                  v-on:click="hidesecondmenu()">
                  {{ $t(childrenItem.title) }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import navMenu from "@/mixins/navMenu";

export default {
  mixins: [navMenu],

}
</script>